import { Link } from "react-router-dom";
import { ShieldCheck, Award, Users, Lightbulb, Briefcase, Repeat, ArrowUpRight } from "lucide-react";

const items = [
  {
    icon: ShieldCheck,
    title: "Certifié Qualiopi",
    desc: "Certificat n° 639711-3 délivré par CERTIFOPAC — garantie qualité reconnue par l'État, valide jusqu'au 13/08/2027.",
  },
  {
    icon: Award,
    title: "Éligible CPF & OPCO",
    desc: "Toutes nos formations sont finançables par votre CPF, OPCO ou plan de développement.",
  },
  {
    icon: Users,
    title: "Formateurs praticiens",
    desc: "Consultants, ingénieurs et entrepreneurs IA en activité, jamais d'intervenants théoriques.",
  },
  {
    icon: Lightbulb,
    title: "Pédagogie active",
    desc: "60% de pratique, projets réels, cas d'usage de votre métier intégrés au programme.",
  },
  {
    icon: Briefcase,
    title: "Format flexible",
    desc: "Présentiel, distanciel ou hybride. Intra-entreprise sur mesure ou inter-entreprise.",
  },
  {
    icon: Repeat,
    title: "Suivi post-formation",
    desc: "Support 6 mois, coaching individuel inclus, accès aux ressources mises à jour.",
  },
];

export default function TrustSignals() {
  return (
    <section className="bg-brand-page py-14 md:py-20 border-y border-brand-line" data-testid="trust-section">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-start">
          <div className="lg:col-span-4">
            <div className="overline">Pourquoi YAFORMIS</div>
            <h2 className="font-heading font-black tracking-tighter text-3xl sm:text-4xl lg:text-[2.6rem] mt-3 text-brand-ink leading-[1.1]">
              Un organisme conçu pour produire des résultats mesurables.
            </h2>
            <p className="mt-4 text-slate-600 leading-relaxed">
              Notre méthode repose sur trois piliers : praticiens experts, projet métier appliqué, suivi long terme.
            </p>
            <div className="mt-8 border-2 border-brand-blue bg-white p-5 relative" data-testid="qualiopi-cert-banner">
              <div className="absolute -top-3 left-4 bg-brand-blue text-white text-[10px] font-bold tracking-[0.18em] uppercase px-2 py-0.5">
                Certification Qualiopi
              </div>
              <div className="flex items-start gap-3">
                <ShieldCheck className="w-8 h-8 text-brand-blue shrink-0 mt-0.5" strokeWidth={1.6} />
                <div>
                  <div className="font-heading font-black text-lg text-brand-ink leading-tight">Certificat n° 639711-3</div>
                  <div className="mt-1 text-xs text-slate-600 leading-relaxed">
                    Délivré par <strong className="text-brand-ink">CERTIFOPAC</strong> au titre de la catégorie « Actions de formation ».
                  </div>
                  <div className="mt-2 inline-flex items-center gap-1.5 bg-brand-surface border border-brand-line px-2.5 py-1 text-xs font-bold text-brand-ink">
                    Valide du 14/08/2024 au 13/08/2027
                  </div>
                  <div className="mt-3">
                    <Link to="/certificat-qualiopi" className="inline-flex items-center gap-1.5 text-sm font-semibold text-brand-blue hover:gap-2.5 transition-all" data-testid="qualiopi-cert-link">
                      Voir le certificat officiel
                      <ArrowUpRight className="w-4 h-4" />
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="lg:col-span-8 grid grid-cols-1 sm:grid-cols-2 gap-px bg-brand-line border border-brand-line">
            {items.map((it) => (
              <div key={it.title} className="bg-white p-6 md:p-8 group hover:bg-brand-surface transition-colors" data-testid={`trust-item-${it.title.replace(/\s/g, '-').toLowerCase()}`}>
                <it.icon className="w-7 h-7 text-brand-blue group-hover:text-brand-cta transition-colors" strokeWidth={1.6} />
                <h3 className="font-heading font-bold text-lg mt-4 text-brand-ink">{it.title}</h3>
                <p className="mt-2 text-sm text-slate-600 leading-relaxed">{it.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
